import script from "./EditMemberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMemberModal.vue?vue&type=script&setup=true&lang=js"

import "./EditMemberModal.vue?vue&type=style&index=0&id=f5c83836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5c83836"]])

export default __exports__